module.exports = __webpack_public_path__ + "img/app-academy-tutor-1.930a9e4f.png";